import types from '../actionTypes/RedirectActionTypes';

/**
 * Reducer to handle the 301 Redirects
 */

export default function RedirectReducer(state = {}, action) {
    switch (action.type) {
        case types.SET_REDIRECT_URL:
            return action.redirectData;
        default:
            return state;
    }
}
